import React from "react";
import { makeStyles, Typography } from "@material-ui/core";
import SentimentDissatisfiedOutlinedIcon from "@material-ui/icons/SentimentDissatisfiedOutlined";
import { useIntl } from "react-intl";

const useStyles = makeStyles((theme) => ({
  main: {
    height: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  textBlock: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: theme.spacing(2),
  },
  icon: {
    fontSize: "6rem",
  },
}));

const NotFoundPage = () => {
  const classes = useStyles();
  const intl = useIntl();

  return (
    <div className={classes.main}>
      <div className={classes.textBlock}>
        <SentimentDissatisfiedOutlinedIcon color={"primary"} className={classes.icon} />
        <Typography variant={"h3"}>{intl.formatMessage({ id: "page_error_title" })}</Typography>
        <Typography variant={"h5"}>{intl.formatMessage({ id: "page_error_subtitle" })}</Typography>
      </div>
    </div>
  );
};

export default NotFoundPage;
